export const RecurringTaskEN = {
    recurringTask: "Recurring task",
    recurringTaskColumns: {
        creator: "Người tạo",
        taskName: "Tên công việc",
        startDate: "Bắt đầu",
        endDate: "Kết thúc",
        assignor: "Người giao việc",
        assignee: "Người thực hiện",
        task: "Công việc",
        recurringCalendar: "Lịch lặp"
    }
}